import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 512" {...props}><g data-name="Layer 2"><g data-name="Capa 1"><path d="M0 90h300v272H0zM0 452a60.07 60.07 0 0060 60h180a60.07 60.07 0 0060-60v-60H0zM240 0H60A60.07 60.07 0 000 60h300a60.07 60.07 0 00-60-60z" /></g></g></svg>);